import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';

import styles from './PropertiesGroup.less';

class PropertiesGroup extends React.PureComponent {
  render() {
    const {children, title} = this.props;
    return (
      <div
        className={classNames(
          styles.dlPropertiesGroup,
          styles.dlPropertiesGroupMargin
        )}
      >
        <div className={styles.dlPropertiesGroupLabel}>{title}</div>
        {children}
      </div>
    );
  }
}

PropertiesGroup.displayName = 'PropertiesGroup';

PropertiesGroup.propTypes = {
  title: PropTypes.string.isRequired,
};

export default PropertiesGroup;
